import Vue from 'vue'
import VueRouter, { Route, RouteLocationNormalized, RouteRecordNormalized, NavigationGuardNext, START_LOCATION } from 'vue-router'

import globalStore from '@/store'

Vue.use(VueRouter)

const BASE_URL = import.meta.env.BASE_URL

const routes = [
  // {
  //   path: BASE_URL + 'matrix',
  //   component: () => import('@/plugins/matrix/MatrixViewer.vue'),
  //   props: (route: Route) => ({
  //     root: '',
  //     subfolder: '',
  //   }),
  // },
  // {
  //   path: BASE_URL + 'map',
  //   component: () => import('@/plugins/layer-map/LayerMap.vue'),
  //   props: (route: Route) => ({
  //     root: '',
  //     subfolder: '',
  //   }),
  // },
  // {
  //   path: BASE_URL + 'maps',
  //   component: () => import('@/plugins/layer-map/LayerMap.vue'),
  //   props: (route: Route) => ({
  //     root: '',
  //     subfolder: '',
  //   }),
  // },
  // {
  //   path: BASE_URL + 'runconfig/:id',
  //   component: () => import('@/sim-runner/RunConfigurator.vue'),
  //   props: (route: Route) => ({
  //     id: route.params.id,
  //   }),
  // },
  {
    name: 'SimulatorExec',
    path: BASE_URL + 'simulator/exec',
    component: () => import('@/layout-manager/SimulatorExec.vue'),
  },
  {
    name: 'SimulatorDataSelect',
    path: BASE_URL + 'simulator/data/select',
    component: () => import('@/layout-manager/SimulatorDataSelect.vue'),
    beforeEnter: chkLoggedIn,
  },
  {
    name: 'SimulatorDataProcess',
    path: BASE_URL + 'simulator/data/process',
    component: () => import('@/layout-manager/SimulatorDataProcess.vue'),
    beforeEnter: chkLoggedIn,
  },
  {
    name: 'Home',
    path: BASE_URL,
    redirect: BASE_URL + 'simulator/exec',
  },
  {
    path: BASE_URL + '*',
    component: () => import('@/layout-manager/LayoutManager.vue'),
    beforeEnter: chkLoggedIn,
  },
  {
    // catch-all back to home page
    path: '*',
    redirect: BASE_URL + 'simulator/exec',
  },
]

// // // individual viz plugins all go into /v/* subpaths
// function vizPlugins(): any[] {
//   const plugins = []
//   for (const plugin of globalStore.state.visualizationTypes.values()) {
//     plugins.push({
//       path: BASE_URL + 'v/' + plugin.kebabName + '/:slug/*',
//       name: plugin.kebabName,
//       component: plugin.component,
//       props: (route: Route) => {
//         const match = route.params.pathMatch
//         const subfolder = match.substring(0, match.lastIndexOf('/'))
//         const yamlConfig = match.substring(match.lastIndexOf('/') + 1)
//         return {
//           root: route.params.slug,
//           subfolder,
//           yamlConfig,
//           thumbnail: false,
//         }
//       },
//     })
//   }

//   return plugins
// }

function chkLoggedIn(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  if (from === START_LOCATION && !globalStore.state.isLoggedIn) {
    // URL直接アクセス時に未ログインの場合はトップ画面に戻す
    next(BASE_URL + 'simulator/exec');
  } else {
    next();
  }
}

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
  // native-like back/forward and top-of-page routing
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

export default router
